import { render, staticRenderFns } from "./MedicalEvaluation.vue?vue&type=template&id=1b9bd819&scoped=true&"
import script from "./MedicalEvaluation.vue?vue&type=script&lang=js&"
export * from "./MedicalEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./MedicalEvaluation.vue?vue&type=style&index=0&id=1b9bd819&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9bd819",
  null
  
)

export default component.exports